import styled from 'styled-components'

export const ContainerSvg = styled.div`
  display: flex;
  justify-content: flex-end;

  svg {
    ${(props) => props.theme.marginLeft}: 20px;
  }
`
